var React = require('react');

function Redo (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m15 14 5-5-5-5","key":0}),React.createElement("path",{"d":"M20 9H9.5A5.5 5.5 0 0 0 4 14.5A5.5 5.5 0 0 0 9.5 20H13","key":1})]);
}

Redo.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"lucide lucide-redo2-icon lucide-redo-2"};

module.exports = Redo;

Redo.default = Redo;
